import React, { useState } from 'react';
// datepicker
import DatePicker from 'react-datepicker';
// datepicker css
import 'react-datepicker/dist/react-datepicker.css';
import '../datepicker.css';
// icons
import { BsCalendar } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

const CheckOut = () => {
  const [endDate, setEndDate] = useState(false);
  const { t } = useTranslation();
  
  return (
<div className="relative w-full h-full">
  <div className="absolute left-3 top-1/2 transform -translate-y-1/2">

          <BsCalendar className='text-accent text-base' />
  
      </div>
      <DatePicker
    className="w-full h-full pl-10" 
    selected={endDate}
        placeholderText={t('Wymeldowanie')}
        onChange={(date) => setEndDate(date)}
      />
    </div>
  );
};

export default CheckOut;
